// extracted by mini-css-extract-plugin
export default {"root":"Switch_root__s3Nvg","input":"Switch_input__c-hBV","track":"Switch_track__oWtU-","thumb":"Switch_thumb__jld+l","label":"Switch_label__Fo3aU"};